import React from 'react';

interface TechnicalInfoProps {
  iterationsPerSecond: number;
  iterationTime: number;
  maxError: number;
  errorVelocity: number;
  currentPathLength: number;
  numberOfPins: number;
}

const formatIterationTime = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds.toFixed(1)}s`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds.toFixed(0)}s`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }
};

const TechnicalInfo: React.FC<TechnicalInfoProps> = ({ iterationsPerSecond, iterationTime, maxError, errorVelocity, currentPathLength, numberOfPins }) => {
  return (
    <div className="mt-8 text-xs text-gray-500">
      <div className="flex flex-col items-center gap-1">
        <div>Path Segments: {currentPathLength}</div>
        <div>Number of Pins: {numberOfPins}</div>
        <div>Iterations/sec: {iterationsPerSecond.toFixed(0)}</div>
        <div>Iteration Time: {formatIterationTime(iterationTime)}</div>
        <div>Max Error: {maxError.toFixed(2)}</div>
        <div>Error Velocity: {errorVelocity.toFixed(2)}%/s</div>
      </div>
    </div>
  );
};

export default TechnicalInfo;